// axios
import axios from 'axios'

const baseURL = process.env.VUE_APP_BASE_API

const service = axios.create({
  baseURL,
  // You can add your headers here
})

// Store reference to notification service
let NotificationService = null

// Track last 403 notification to prevent duplicates
let last403Notification = 0
const NOTIFICATION_COOLDOWN = 1000 // 1 second cooldown

// Method to set Vue instance (called from main.js)
export const setVueInstance = () => {
  // Import notification service dynamically to avoid circular dependency
  import('./services/notification.service').then((module) => {
    NotificationService = module.default
  })
}

service.interceptors.request.use(
  (config) => {
    const url = config.url.toLowerCase()
    if (
      url.match(/(s3-|s3\.)?(.*)\.amazonaws\.com/) &&
      url.indexOf('x-amz-credential') >= 0
    ) {
      config.transformRequest = [
        (data, headers) => {
          delete headers.common.Authorization
          return data
        },
      ]

      return config
    }

    return config
  },
  (error) => {
    console.error(error) // for debug
    return Promise.reject(error)
  }
)

// Response interceptor to handle errors globally
service.interceptors.response.use(
  (response) => {
    // Return successful responses as-is
    return response
  },
  (error) => {
    // Handle 403 Forbidden errors
    if (error.response && error.response.status === 403) {
      // Check if we recently showed a 403 notification (prevent duplicates)
      const now = Date.now()
      const timeSinceLastNotification = now - last403Notification

      // Only show notification if enough time has passed
      if (timeSinceLastNotification > NOTIFICATION_COOLDOWN) {
        last403Notification = now

        // Show notification for insufficient permissions
        if (NotificationService) {
          NotificationService.permissionDenied()
        } else {
          // Fallback to console if service not available
          console.error(
            '403 Forbidden: Insufficient permission to perform this action'
          )
        }
      }

      // Mark error as handled globally
      error.handledGlobally = true
    }

    // Return the error to allow component-level handling if needed
    return Promise.reject(error)
  }
)

export default service
